import { useDisplayCurrency } from "../../contexts/DisplayCurrencyContext"

export default function Money({ amount, className = "" }: { amount: number; className?: string }) {
  const { currency, rates, error } = useDisplayCurrency()
  const rate = rates[currency]?.rate
  const converted = !error && currency && Number.isFinite(rate) && rate > 0
    ? new Intl.NumberFormat("en-GB", { style: "currency", currency, currencyDisplay: "code" }).format(amount * rate)
    : null
  return (
    <span className={`inline-flex flex-col items-end tabular-nums ${className}`}>
      <span className="font-bold">{new Intl.NumberFormat("en-GB", { style: "currency", currency: "EUR" }).format(amount)}</span>
      {converted && <span className="text-xs font-normal leading-snug opacity-80">(≈ {converted})</span>}
    </span>
  )
}
